import { render } from "./extra_buttons.vue?vue&type=template&id=f00594fe"
import script from "./extra_buttons.js?vue&type=script&lang=js"
export * from "./extra_buttons.js?vue&type=script&lang=js"

import "./extra_buttons.vue?vue&type=style&index=0&id=f00594fe&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__